// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606230833/js/" + chunkId + "." + {"44":"1bdcd7e4","225":"dbc11c8f","481":"ac7e31aa","486":"8f38931e","770":"1211f22a"}[chunkId] + ".0.897202268066468.chunk.js";
};